import React from 'react'
import { Formik } from 'formik'
import { Button, CircularProgress } from '@material-ui/core'
import { Save } from '@material-ui/icons'
import { useStyles } from './SeatsDistribution.style'
import SeatSettings from './SeatSettings/SeatSettings'

export const SeatsDistribution = ({
  values,
  handleSubmit,
  onCancel,
  actionPending
}) => {
  const classes = useStyles()

  return (
    <Formik
      enableReinitialize
      initialValues={values}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <form
          noValidate
          onSubmit={handleSubmit}
          className={classes.formContainer}>
          <SeatSettings />
          <div className={classes.actionsContainer}>
            <Button
              onClick={onCancel}
              disabled={isSubmitting}
              autoFocus={false}
              color='primary'>
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={actionPending || isSubmitting}
              color='primary'
              variant='contained'
              startIcon={<Save />}
              autoFocus={false}>
              {actionPending || isSubmitting ? (
                <CircularProgress size={24} color='secondary' />
              ) : (
                'Guardar'
              )}
            </Button>
          </div>
        </form>
      )}
    </Formik>
  )
}

export default SeatsDistribution
